import { Question } from './Question';
import { ValidationRule } from './TextQuestion';

export class ShortTextQuestion extends Question {
    validationRule: ValidationRule;
}
